import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";

interface IProps extends ICellRendererParams {
    //
}

class TotalCell implements ICellRendererComp {
    declare eGui: HTMLElement;
    declare eValue: HTMLElement;

    private renderValue(params: IProps) {
        const { formatValue, value } = params;
        this.eValue.innerText = formatValue(value);
    }

    private buildBaseElement() {
        // create the cell
        this.eGui = document.createElement("div");
        this.eGui.className = "planCell";
        this.eGui.style.width = "100%";
        this.eGui.innerHTML = '<div class="actualValue"></div>';

        // get references to the elements we want
        this.eValue = this.eGui.querySelector(".actualValue");
    }

    refresh(params: IProps): boolean {
        // set value into cell again
        this.renderValue(params);

        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.buildBaseElement();

        // set value into cell
        this.renderValue(params);
    }
}

export { TotalCell };
